<template>
	<div class="block-notification">
		{{this.data.taxCode}}
		<div class="icon-notification ml-1">

			<span :class="typeComponent ? typeComponent : 'd-none'" :ref="this.data.taxCode" @mouseover="handleHover" ></span>

			<div class="box-tooltip" :style="{ left: mouseX + 'px', top: mouseY + 'px' }">
				<component :is="this.column?.actionType" :dataTooltip="this.data"></component>
			</div>
		</div>
	</div>
</template>
<script>
import { getCurrentInstance, ref, reactive, onMounted, computed  } from 'vue';
import TARiskCustomerVendorInfoPopup from '@/views/tax/tARiskCustomerVendor/TARiskCustomerVendorInfoPopup.vue';

export default {
    props:{
    	data:{}, // dữ liệu của hàng
			column: {}, // Lưu thông tin của các cột
    },
	components: {TARiskCustomerVendorInfoPopup},
	data() {
    	return {
			mouseX: 0,
			mouseY: 0
		};
	},
    setup: props => { 
			const {proxy} = getCurrentInstance()
			const typeComponent = ref('');
			onMounted(() => {
				switch (props.column?.actionType) {
					case 'TARiskCustomerVendorInfoPopup':
						// Hiển thị icon ? cạnh dữ liệu td  
						typeComponent.value = 'alert-taxcode';
						break;
					default:
						break;
				}
			});
			return  {
				typeComponent,
				location,
			}
    },
	methods:{
		handleHover (event) {
			// Lấy vị trí của con trỏ chuột trong phần tử
			const nameRef = this.data.taxCode;
			const elementA = this.$refs[nameRef];
			if(elementA){
				const rect = elementA.getBoundingClientRect();
				this.mouseY = rect.top ;
				// + window.scrollY
				this.mouseX = rect.left ;
				// + rect.width
			}
		}
	}
}
</script>
<style lang="scss">

	.block-notification{
		display: flex;
    align-items: center;
		.icon-notification{
			position: relative;
			> span{
				display: block;
				height: 24px;
				width: 24px;
				position: relative;
				&.alert-taxcode{
					&:before{
						content: "";
						position: absolute;
						background: transparent url($ms-image-sprites) no-repeat;
						height: 24px;
						width: 24px;
						top: 0;
						left: 0;
						background-position: -455px -120px;
						// transform: scale(0.8);
					}
				}
			}
			.box-tooltip{
				display: none;
				position: fixed;
				z-index: 9999999;
				top: 133px;
				left: 368px;
				padding: 20px 0 0 18px;
			}
			&:hover{
				.box-tooltip{
					display: block;
				}
			}
		}
	}
</style>